class BackToTop {
	constructor(element, options = {}) {
		this.element = element;
		this.threshold = options.threshold ?? 400;
		this.ticking = false;

		this.onScroll = this.onScroll.bind(this);
		this.updateVisibility = this.updateVisibility.bind(this);
		this.handleClick = this.handleClick.bind(this);

		this.init();
	}

	init() {
		this.element.addEventListener('click', this.handleClick);
		window.addEventListener('scroll', this.onScroll, { passive: true });
		this.updateVisibility();
	}

	onScroll() {
		if (this.ticking) {
			return;
		}

		this.ticking = true;
		window.requestAnimationFrame(this.updateVisibility);
	}

	updateVisibility() {
		const isVisible = window.scrollY > this.threshold;

		this.element.classList.toggle('is-visible', isVisible);
		this.element.setAttribute('aria-hidden', String(!isVisible));
		this.element.tabIndex = isVisible ? 0 : -1;
		this.ticking = false;
	}

	handleClick(event) {
		event.preventDefault();

		const prefersReducedMotion = window.matchMedia(
			'(prefers-reduced-motion: reduce)'
		).matches;

		window.scrollTo({
			top: 0,
			behavior: prefersReducedMotion ? 'auto' : 'smooth',
		});
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const button = document.querySelector('.back-to-top');

	if (!button) {
		return;
	}

	new BackToTop(button);
});

export default BackToTop;
